// extracted by mini-css-extract-plugin
module.exports = {"container":"Section10_container__ajabk","form":"Section10_form__ZlQk5"};